import urljoin from "url-join";

import { rewriteUrls } from "@/app/_internal/rewriteUrls/rewriteUrls";

export const BLOG_SLUG = "blog" as const;
export const LOYALTY_BLOG_SLUG = "loyalty-blog" as const;

export const buildBlogSlug = (slug?: string, isLoyalty?: boolean, locale?: string): string => {
  const blogSlug = isLoyalty ? LOYALTY_BLOG_SLUG : BLOG_SLUG;
  const basePath = `/${blogSlug}`;
  const localizedBasePath = locale ? rewriteUrls(basePath, locale) : basePath;

  return urljoin("/", localizedBasePath, slug ?? "");
};
